import { Component, type ErrorInfo, type ReactNode, useEffect } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { router, entry } from '@/routes';
declare global {
  var __onautoRouteInventory:
    | {
        routes: {
          pattern: string;
          path: string;
          title: string;
          page: string;
          standalone: boolean;
          isPublic: boolean;
          entersFrom?: string;
        }[];
        entry: typeof entry;
      }
    | undefined;
}
class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error, _info: ErrorInfo) {
    console.error(error);
  }
  render() {
    return this.state.failed ? (
      <main className="mx-auto max-w-xl p-8">
        <h1 className="font-heading text-xl font-semibold">Bus times are unavailable</h1>
        <p className="mt-3 text-muted-foreground">Please reload this page to try again.</p>
      </main>
    ) : (
      this.props.children
    );
  }
}
export function App() {
  useEffect(() => {
    document.getElementById('root')?.setAttribute('data-app-ready', '1');
    globalThis.__onautoRouteInventory = {
      routes: Object.values(router.routesById)
        .filter((route) => route.id !== '__root__')
        .map((route) => ({
          pattern: route.fullPath.replace(/\$([a-zA-Z][\w]*)/g, '[$1]'),
          path: route.fullPath,
          title: route.options.staticData?.title ?? '',
          page: route.options.staticData?.page ?? '',
          standalone: route.options.staticData?.standalone ?? false,
          isPublic: route.options.staticData?.isPublic ?? true,
        })),
      entry,
    };
  }, []);
  return (
    <AppErrorBoundary>
      <RouterProvider router={router} />
    </AppErrorBoundary>
  );
}
